<template>
  <div style="height: 100%" class="order-list">
    <van-tabs v-model="active" :animated="animate" @change="changeTab" swipeable sticky :ellipsis="false">
      <van-tab
        :title="item.text"
        v-for="item in orderTabs"
        :key="item.status"
        :name="item.status"
        :badge="renderStatus(item.status)"
        style="height: 100%"
      >
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="order-list-pull-box">
          <van-list
            v-if="orderListData"
            class="order-list-content"
            v-model="loading"
            :error-text="orderListData.length === 0 ? '' : errorText"
            :error.sync="error"
            :finished="finished"
            :immediate-check="false"
            :finished-text="orderListData.length < 3 ? '' : '没有更多了'"
            @load="getList"
          >
            <section class="order-container">
              <div class="order-container-item" v-for="order in orderListData" :key="order.orderId">
                <order-item :order="order" @showPopup="openPopup" :is-refund="active == '80'"></order-item>
                <div
                  class="btn-wrapper"
                  v-if="isShowPickCode(order) || order.status === 0 || order.status === 22 || order.status === 52"
                >
                  <van-button
                    v-if="isShowPickCode(order)"
                    hairline
                    round
                    plain
                    class="gory-btn btn"
                    color="#D9D9D9"
                    size="small"
                    @click="openPopup(order)"
                  >
                    核销码
                  </van-button>
                  <van-button
                    v-if="order.status === 0"
                    hairline
                    round
                    plain
                    class="gory-btn btn"
                    color="#D9D9D9"
                    size="small"
                    @click="thirdPay(order)"
                  >
                    他人代付
                  </van-button>
                  <van-button
                    style="margin-left: 8px"
                    hairline
                    round
                    plain
                    v-if="order.status === 0"
                    class="btn"
                    color="#1E8DFF"
                    size="small"
                    v-reClick="() => toPay(order)"
                  >
                    立即支付
                  </van-button>
                  <van-button
                    style="margin-left: 8px"
                    hairline
                    round
                    plain
                    v-if="order.status === 22 || order.status === 52"
                    class="btn"
                    color="#1E8DFF"
                    size="small"
                    v-reClick="() => toBuyAgain(order)"
                  >
                    再来一单
                  </van-button>
                </div>
              </div>
            </section>

            <van-empty
              style="padding: 0; height: calc(100vh - 104px)"
              v-if="orderListData.length === 0 && !loading"
              image="//static.91jkys.com/attachment/20210428105356694_a8c6c937d65640aaae9cf82b8c4af801.png"
              :description="error ? errorText : '暂无订单'"
            />
          </van-list>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>
    <van-popup round overlay-class="self-popup-overlay" class="self-popup-box" v-model="isShowPopup">
      <div class="popup-container">
        <p class="popup-container-title">请凭核销码取货</p>
        <p class="popup-container-code">{{ pickCode }}</p>

        <p class="popup-container-time">
          <span class="label">自提时间: &nbsp;</span>
          <span>&nbsp; {{ timeSection }}</span>
        </p>
      </div>
      <div style="margin-top: 24px; text-align: center">
        <van-icon @click="closePopup" color="#FFFFFF" name="cap-toastfail" size="24px" />
      </div>
    </van-popup>
    <van-popup
      round
      position="bottom"
      overlay-class="self-popup-overlay"
      class="again-popup-box"
      v-model="isShowBuyAgain"
    >
      <div class="popup-container">
        <div class="title">
          再来一单
          <div class="cancel" @click="isShowBuyAgain = false">取消</div>
        </div>
        <div class="tips">您还购买了其他商品，是否一并下单？</div>
        <div class="content">
          <van-checkbox-group v-model="checkList" ref="checkboxGroup">
            <div class="order-card" v-for="(item, key) in buyAgainOrder" :key="key">
              <div class="p16">订单编号：{{ item.orderId }}</div>
              <div class="product-list">
                <div style="width: 30px">
                  <van-checkbox :name="key" icon-size="17px" @click="handleChangeChild"></van-checkbox>
                </div>
                <div style="width: calc(100% - 30px)">
                  <goods-list :goodsList="item.orderDetails" :isShowGoodList="true"></goods-list>
                </div>
              </div>
            </div>
          </van-checkbox-group>
        </div>
        <div class="bottom">
          <van-checkbox v-model="checkedAll" icon-size="17px" @change="checkToogleAll" @click.native="clickToogleAll">
            <span style="color: #333">全选</span>
          </van-checkbox>
          <van-button
            size="mini"
            type="primary"
            round
            style="width: 88px; height: 32px"
            :disabled="!checkList.length"
            v-reClick="submitOrder"
          >
            确定
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import utils from '@/util/index.js';
// import { orderStatusEnum } from '@/constant';
import orderItem from './orderItem.vue';
import goodsList from '@/components/goodsList.vue';
import { Dialog } from '@zyf2e/capui-mobile';
import ZYPay from '@zyf2e/checkout-sdk';

export default {
  components: {
    orderItem,
    goodsList
  },
  data() {
    return {
      active: null,
      currentTab: null,
      animate: false,
      refreshing: false, // 是否处于下拉加载状态
      loading: true,
      error: false,
      finished: false,
      fetchLoading: false,
      pageNo: 0,
      pageSize: 10,
      budget: {}, // 徽标数量
      orderTabs: [
        {
          text: '全部',
          status: ''
        },
        {
          text: '待付款',
          status: 0
        },
        {
          text: '待发货',
          status: 12
        },
        {
          text: '待收货',
          status: 21
        },
        {
          text: '售后/退款',
          status: 80
        }
      ],
      orderListData: [],
      errorImage: null,
      errorText: '系统开小差了，请稍后重试',
      isShowPopup: false,
      pickCode: '',
      timeSection: '',
      isShowBuyAgain: false,
      checkedAll: false,
      buyAgainOrder: [],
      checkList: [0],
      payLock: false
    };
  },
  async mounted() {
    this.animate = true; // 首次渲染完成开启转场动画
    // 初始化tabs 数据list
    const { active } = this.$route.params;
    this.currentTab = Number(active);

    // currentTab === 0 status = '' 查全部 currentTab == 1 status == 0 查待付款
    this.active = active == 0 ? '' : active == 1 ? 0 : Number(active);

    this.initOrderListData(this.active);
    this.initOrderBudget();
    await ZYPay.init({
      ...util.ZYpayConfig
    });
    // window.addEventListener('pageshow', (event) => {
    //   if (event.persisted) {
    //     window.history.replaceState(null, '', `#/order-list/${this.active}`);
    //   }
    // });
  },
  methods: {
    // 获取订单徽标数量
    async initOrderBudget() {
      const res = await this.$fetch.fetchOrderBudget();
      this.budget = res;
    },
    //
    renderStatus(status) {
      if (status === 0) {
        return this.budget.waitingPayNum || null;
      }
      if (status === 12) {
        return this.budget.waitingSendNum || null;
      }
      if (status === 21) {
        return this.budget.waitingReceiveNum || null;
      }
      if (status === 80) {
        return this.budget.refundingNum || null;
      }
      return null;
    },
    changeTab(val) {
      this.refreshing = false;
      this.fetchLoading = false;
      this.currentTab = val === '' ? 0 : val === 0 ? 1 : val;

      window.history.replaceState(null, '', `#/order-list/${this.currentTab}`);

      this.orderListData = [];
      this.initOrderListData(val);
    },
    initOrderListData(val) {
      this.finished = false;
      this.loading = true;
      this.pageNo = 0;
      this.error = false;
      this.getList(val);
    },
    async getList(tab = this.active) {
      await utils.wait(300); // 转场动画完成后 请求数据
      if (this.fetchLoading) return; // 避免请求没回来 就发起第二次请求
      this.fetchLoading = true;
      this.loading = true;
      // ZYToast.setOnceConfig({ noToast: true });

      try {
        const data = await this.$fetch.fetchGetOrderList({
          pageNo: (this.pageNo || 0) + 1,
          pageSize: this.pageSize,
          orderStatus: tab,
          channel: 'MEDIC_SALE'
        });

        const { pageNo, list } = data;

        const transTab = tab === '' ? 0 : tab == 0 ? 1 : tab;
        const list1 = transTab.toString() === this.currentTab.toString() ? list : [];
        this.pageNo = transTab.toString() === this.currentTab.toString() ? pageNo : this.pageNo;
        this.orderListData = [...this.orderListData, ...list1];
        this.finished = list.length < this.pageSize;
      } catch (error) {
        this.error = true;
        const { response, code } = error;
        this.errorText = error.message || this.errorText;
        if (!response && !code) {
          this.errorText = '请检查网络后再试';
          return;
        }
        if (response.status >= 500) {
          this.errorText = '系统开小差了，请稍后重试';
        }
      }
      this.fetchLoading = false;
      // ZYToast.clearOnceConfig();
      this.refreshing = false;
      this.loading = false;
    },
    onRefresh() {
      if (this.refreshing) {
        this.orderListData = [];
        this.initOrderListData();
        this.refreshing = false;
      }
    },
    async toPay(order) {
      if (this.payLock) {
        this.$toast('支付中，请勿重复点击')
        return
      }
      this.payLock = true
      const backParams = { orderId: order.orderId, prescription: order.orderType === 7 ? '1' : '2' };
      const payParams = {
        failUrl: encodeURIComponent(`${window.location.origin}#/payment/fail${util.parseParam(backParams)}`),
        successUrl: encodeURIComponent(`${window.location.origin}#/payment/success${util.parseParam(backParams)}`)
      };

      try {
        const { tradeNo = '' } = await this.$fetch.fetchGetTradeNo({
          orderId: order.orderId
        });
        await ZYPay.prePay({ tradeNo, ...payParams });
        this.payLock = false
      }catch(error) {
        this.payLock = false
        if (error === 'INIT_ADAPT_ERROR') {
          Dialog.confirm({
            title: '温馨提示',
            message: '支付环境异常,请刷新重试',
            confirmButtonText: '立即重试'
          })
            .then(() => {
              window.location.reload()
              // on confirm
            })
            .catch((action) => {
              // on cancel or assist
            });
            return
        }
        this.$toast(error && error.message ? error.message : error);
      }
    },
    async toBuyAgain(order) {
      const orderList = await await this.$fetch.toBuyAgain({
        orderId: order.orderId,
        parentId: order.orderParentId
      });

      if (orderList.length === 1) {
        this.addToCart(orderList[0].orderDetails);
        return;
      }
      this.buyAgainOrder = orderList;
      this.checkedAll = false;
      this.checkList = [0]; // 默认选择第一项
      this.isShowBuyAgain = true;
    },
    handleChangeChild() {
      if (this.checkList.length === this.buyAgainOrder.length) {
        this.checkedAll = true;
      } else {
        this.checkedAll = false;
      }
    },
    checkToogleAll(val) {
      if (val) this.$refs.checkboxGroup.toggleAll(val);
    },
    clickToogleAll() {
      this.$refs.checkboxGroup.toggleAll(!this.checkedAll);
    },
    submitOrder() {
      let itemList = [];
      this.checkList.map((key) => {
        itemList = itemList.concat(this.buyAgainOrder[key].orderDetails);
      });
      this.addToCart(itemList);
    },
    async addToCart(itemList) {
      const res = await this.$fetch.batchAddCart({ itemList });

      const query = {
        isDrug: res.itemListAdded.length ? res.itemListAdded[0].isDrug : '',
        itemList: res.itemListAdded.map((item) => item.itemId).join(',')
      };
      if (res.code === 'HY_ADD_CARTS_PART_FAIL') {
        await this.$toast({
          duration: 2000,
          message: res.message
        });
        setTimeout(() => {
          this.$router.push({
            name: 'requestCart',
            query
          });
        }, 2000);
        return;
      }
      if (res.code === 'HY_SUCCESS') {
        this.$router.push({
          name: 'requestCart',
          query
        });
        return;
      }
    },
    thirdPay(order) {
      this.$router.push({
        name: 'thirdPay',
        query: {
          orderId: order.orderId
        }
      });
    },
    openPopup(order) {
      this.pickCode = order.pickCode;
      this.timeSection = order.timeSection;
      this.isShowPopup = true;
    },
    closePopup() {
      this.isShowPopup = false;
      // this.$nextTick(() => {
      //   this.pickCode = '';
      //   this.timeSection = '';
      // });
    },
    isShowPickCode(order = {}) {
      // 待取货 状态 51就好
      const isFatherOrder = order.subOrders && Array.isArray(order.subOrders) && order.subOrders.length > 0;
      return !isFatherOrder && order.status === 51;
    }
  }
};
</script>

<style lang="less" scoped>
.order-list {
  /deep/ .van-info {
    font-size: 10px;
    height: 16px;
    line-height: 16px;
    border: 1px solid transparent;
    font-weight: normal;
    background-color: #fa4b4b;
    padding: 0px 4px;
  }
}

.order-container {
  padding: 12px;
  &-item {
    background: #fff;
    border-radius: 8px;
    padding: 0 12px;
    padding-top: 20px;
    margin-bottom: 12px;
  }
}
.btn-wrapper {
  text-align: right;
  background: #ffffff;
  padding-bottom: 16px;
  .btn {
    height: 32px;
  }
  .gory-btn {
    /deep/ .van-button__content {
      color: #595959;
    }
  }
  .btn-pay {
    width: 78px;
    height: 32px;
    border-radius: 8px;
    background: #1e8dff;
  }
}
.again-popup-box {
  .popup-container {
    background: #f5f5f5;
    .title {
      position: relative;
      height: 48px;
      line-height: 48px;
      text-align: center;
      font-weight: 500;
      color: #262626;
      font-size: 18px;
      background: #fff;
      .cancel {
        position: absolute;
        right: 0;
        width: 68px;
        text-align: center;
        top: 0;
        font-weight: 400;
        color: #8c8c8c;
        font-size: 16px;
      }
    }
    .tips {
      font-weight: 400;
      color: #ff8200;
      line-height: 12px;
      font-size: 12px;
      padding: 16px;
      background: #fff7e6;
    }
    .content {
      height: 305px;
      overflow-y: auto;
      // min-height: 187px;
      padding: 12px 15px 40px 10px;
      .order-card {
        background: #fff;
        margin-bottom: 12px;
        border-radius: 8px;
        .product-list {
          display: flex;
          width: 100%;
          overflow-x: hidden;
          align-items: center;
          padding: 0 12px 16px 18px;
        }
      }
    }
    .bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 14px 12px 14px 28px;
      background: #fff;
    }
  }
}
.self-popup-box {
  background: transparent;
  .popup-container {
    width: 100%;
    padding: 36px 16px;
    background: #fff;
    border-radius: 12px;
    text-align: center;
    color: #262626;
    font-size: 14px;
    min-width: 270px;
    &-title {
      margin-bottom: 20px;
    }
    &-code {
      font-size: 32px;
      color: #1e8dff;
      font-weight: 500;
      margin-bottom: 32px;
    }
    &-time {
      width: 100%;
      font-size: 12px;
      color: #1e8dff;
      .label {
        color: #8c8c8c;
      }
    }
  }
}
</style>
